import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Paper,
} from "@mui/material";

const UserList = ({ users, handleSelect }) => {
  return (
    <Paper elevation={3} style={{width: '100%'}}>
      <List>
        {users.map((user, u) => {
          return (
            <div key={`${u}-${user._id}`}>
              <ListItem
                key={`listitem-${user._id}`}
                // secondaryAction={
                //   <MoreVertIcon onClick={(e) => handleOpen(e, user)} />
                // }
              >
                <ListItemButton
                  onClick={() => {
                    handleSelect(user.email);
                    
                  }}
                >
                  {user.firstName} {user.lastName} | {user.email}
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
    </Paper>
  );
};

export default UserList;
